import type { Require } from 'modules/types'
import React from 'react'
import { Page, PageProps } from './page'

export interface PublicPageProps
  extends Require<PageProps, 'description' | 'openGraph'> {}

export const PublicPage: React.FC<PublicPageProps> = ({ ...props }) => {
  return <Page {...props} />
}
